import { Draft, DraftState } from '@/types';
import { hasOwnProperty } from '@/utils/hasOwnProperty';

export const isDraftState = (draft: Draft | DraftState): draft is DraftState =>
  hasOwnProperty(draft, 'validation');
